import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formatea un número en formato español (separador de millar: ".", separador decimal: ",")
 * @param {number} num - Número a formatear
 * @param {number} decimals - Número de decimales (por defecto 2)
 * @returns {string} Número formateado
 */
export function formatNumberES(num, decimals = 2) {
  if (num === null || num === undefined || isNaN(num)) {
    return '0,00';
  }
  
  const fixed = num.toFixed(decimals);
  const parts = fixed.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1] || '';
  
  return decimalPart ? `${integerPart},${decimalPart}` : integerPart;
}
